/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const ownScheduleTeamsResponseOutputTeamsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const ownScheduleTeamsResponseOutputTeamsItemNameMax = 500;

export const ownScheduleTeamsResponseOutputTeamsMax = 100;

export const OwnScheduleTeamsResponseOutput = zod.object({
  teams: zod
    .array(
      zod.object({
        id: zod.uuid().regex(ownScheduleTeamsResponseOutputTeamsItemIdRegExp),
        name: zod.string().min(1).max(ownScheduleTeamsResponseOutputTeamsItemNameMax),
      }),
    )
    .max(ownScheduleTeamsResponseOutputTeamsMax),
});

export type OwnScheduleTeamsResponseOutput = zod.input<typeof OwnScheduleTeamsResponseOutput>;
export type OwnScheduleTeamsResponseOutputOutput = zod.output<
  typeof OwnScheduleTeamsResponseOutput
>;
